
import { Vue, Component, Prop } from 'vue-property-decorator'

import PreviewLabelValue from '@/stories/preview-label-value/PreviewLabelValue.vue'
import { EmailChannel } from '@/modules/notification-center/event-trigger/types/triggerTypes'
import TriggerVariableCard from '@/modules/notification-center/event-trigger/components/TriggerVariablesCard.vue'
import { isContentContainsVariables } from '@/modules/notification-center/event-trigger/utils/isContentContainsVariables'

@Component({
  name: 'EmailPreviewComponent',
  components: {
    PreviewLabelValue,
    TriggerVariableCard
  }
})
export default class EmailPreviewComponent extends Vue {
  @Prop({ type: Object, required: true })
  readonly channel!: EmailChannel

  @Prop({ type: Boolean, required: false, default: false })
  readonly loading!: boolean

  @Prop({ type: Array, required: false, default: [] })
  readonly variables!: string[]

  isContentContainsVariables = isContentContainsVariables

  get languages() {
    return [
      { code: 'en', label: 'En' },
      { code: 'ckb', label: 'Ckb' },
      { code: 'ar', label: 'Ar' }
    ]
  }
}
